<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search for shifts"
    [(searchTerm)]="searchTerm"
    (searchChange)="onShiftSearchChange($event)"
    iconSize="small">
  </app-searchbar>
  <div class="filter-container">
    <app-add-button class="desktop-buttons" buttonText="Add Shift" variant="primary" (buttonClick)="onAddShift()"></app-add-button>
    <div class="buttons-row">
      <app-add-button class="mobile-buttons" buttonText="Add Shift" variant="primary" (buttonClick)="onAddShift()"></app-add-button>
    </div>
  </div>
</div>

<!-- Shimmer Loading -->
<div *ngIf="loadingShifts" class="table-section">
  <app-loading-table-shimmer [columns]="shimmerColumns" [rows]="5"></app-loading-table-shimmer>
</div>

<!-- Shifts Table -->
<div class="table-section" *ngIf="!loadingShifts && filteredShifts.length > 0">
  <div class="table-container">
    <div class="table-scroll-wrapper" #shiftsTableScrollWrapper>
      <table class="shifts-table">
        <thead>
          <tr>
            <th>Shift Name</th>
            <th>Working Days / Timings</th>
            <th>Off Days</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let shift of filteredShifts; trackBy: trackByShiftId; let i = index"
              class="shift-row"
              [style.animation-delay]="(i * 0.05) + 's'"
              [attr.data-index]="i">
            <td><div class="shift-name">{{ shift.shift_name }}</div></td>
            <td><div class="working-days-timings">{{ formatWorkingDaysTimings(shift.working_days) }}</div></td>
            <td><div class="off-days">{{ shift.off_days }}</div></td>
            <td>
              <div class="actions-cell" (click)="$event.stopPropagation()">
                <button class="actions-button" (click)="toggleShiftActionsDropdown($event, shift.id)">
                  <ng-container *ngTemplateOutlet="threeDotsIcon"></ng-container>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Empty State -->
<div *ngIf="!loadingShifts && filteredShifts.length === 0" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    [title]="searchTerm ? 'No Results Found' : 'No shifts to show!'"
    [description]="searchTerm ? 'Try adjusting your search criteria' : 'Please create a shift to continue.'"
    [actionText]="'Add Shift'"
    [showAction]="!searchTerm"
    [actionClick]="getAddShiftAction()">
  </app-empty-result>
</div>

<!-- Modals -->
<app-add-shift-modal
  [isVisible]="showAddShiftModal"
  [editMode]="editShiftMode"
  [editShiftId]="editShiftId"
  [editData]="editShiftData"
  (closeModal)="onCloseAddShiftModal()"
  (saveShift)="onSaveShift($event)">
</app-add-shift-modal>

<app-success-modal
  [isVisible]="showSuccessModal"
  [data]="successModalData"
  (close)="onSuccessModalClose()">
</app-success-modal>

<app-confirmation-modal
  [isVisible]="showConfirmationModal"
  [data]="confirmationModalData"
  (cancel)="onConfirmationCancel()"
  (confirm)="onConfirmationConfirm()">
</app-confirmation-modal>

<!-- Global Shift Actions Dropdown -->
<div class="actions-dropdown-menu"
     *ngIf="activeShiftActionsDropdown && selectedShiftForDropdown"
     [id]="'shift-dropdown-' + activeShiftActionsDropdown">
  <div class="dropdown-item" (click)="onEditShift(selectedShiftForDropdown!)">
    <div class="dropdown-content">
      <span class="dropdown-text">Edit</span>
      <img src="/assets/images/pencil.svg" alt="Edit" class="dropdown-icon" width="14" height="14">
    </div>
  </div>
  <div class="dropdown-item delete-item" (click)="onDeleteShift(selectedShiftForDropdown!)">
    <div class="dropdown-content">
      <span class="dropdown-text">Delete</span>
      <img src="/assets/images/trash.svg" alt="Delete" class="dropdown-icon" width="14" height="14">
    </div>
  </div>
</div>

<!-- Three-dot icon template -->
<ng-template #threeDotsIcon>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8.66667C8.36819 8.66667 8.66667 8.36819 8.66667 8C8.66667 7.63181 8.36819 7.33333 8 7.33333C7.63181 7.33333 7.33333 7.63181 7.33333 8C7.33333 8.36819 7.63181 8.66667 8 8.66667Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 4C8.36819 4 8.66667 3.70152 8.66667 3.33333C8.66667 2.96514 8.36819 2.66667 8 2.66667C7.63181 2.66667 7.33333 2.96514 7.33333 3.33333C7.33333 3.70152 7.63181 4 8 4Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 13.3333C8.36819 13.3333 8.66667 13.0349 8.66667 12.6667C8.66667 12.2985 8.36819 12 8 12C7.63181 12 7.33333 12.2985 7.33333 12.6667C7.33333 13.0349 7.63181 13.3333 8 13.3333Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</ng-template>
